module.exports = __webpack_public_path__ + "img/LUB00036.1688953a.png";